type Subscriber = (event: any) => void;

export class EventEmitter<TEvents> {
  private events: Map<TEvents, Map<Subscriber, Subscriber>>;

  constructor(events: TEvents[]) {
    this.events = new Map(events.map(event => [event, new Map()]));
  }

  emit(event: TEvents, data?: any) {
    this.events.get(event)?.forEach(subFn => {
      subFn(data);
    });
  }

  on(event: TEvents, subFn: Subscriber) {
    this.events.get(event)?.set(subFn, subFn);

    return () => {
      this.events.get(event)?.delete(subFn);
    };
  }
}
